import { getFeatureToggleClient } from 'infra/featureToggles'

export default function isJobTableDocumentTypeFilterEnabled(): boolean {
  return getFeatureToggleClient().variation(
    'WorkPortal.JobTableDocumentTypeFilterEnabled',
    false,
  )
}
